import {
  email,
  max,
  max_value as maxValue,
  min,
  min_value as minValue,
  required,
} from 'vee-validate/dist/rules'
import { extend } from 'vee-validate'

extend('checkedPolicy', {
  validate: value => value === true,
})
extend('email', email)
extend('max', max)
extend('max_value', maxValue)
extend('min', min)
extend('min_value', minValue)
extend('password', {
  validate: value => /^[\w-!#$%&()*+,.;=@^~]*$/i.test(value),
})
extend('passwordMatch', {
  validate: (value, { other }) => value === other,
  params: [{ name: 'other', isTarget: true }],
})
extend('passwordNotAllNumeric', {
  validate: value => !!value.replace(/\d/g, '').length,
})
extend('passwordNumber', {
  validate: value => /\d/.test(value),
})
extend('phone', {
  validate: value => /^\+?[\d\s]+$/.test(value) && value.length < 24,
})
extend('required', required)
